<!-- 采购计划查询 -->
<template>
  <div>
    <!-- 搜索 -->
    <div class="container">
      <e-search
        :data="queryData"
        :field-list="fieldList"
        :list-type-info="listTypeInfo"
        @handleFilter="handleFilter"
        @handleReset="handleReset"
      ></e-search>
    </div>

    <div class="container">
      <div class="handle-wrapper">
        <eui-btn
          type="primary"
          font-size="12px"
          @click.native.prevent="exporPlanTrackLogSummary"
        >
          导出概要
        </eui-btn>
        <eui-btn
          type="primary"
          font-size="12px"
          @click.native.prevent="exportPlanTrackLogDetail"
        >
          导出明细
        </eui-btn>
      </div>
      <!-- table -->
      <e-table-list
        :table-data="tableData"
        :table-label="tableLabel"
        :index-show="true"
      >
        <template #code="tData">
          <eui-btn
            type="text"
            font-size="12px"
            @click="handleCodeDetail(tData.scope.row)"
          >
            {{ tData.scope.row.purchasePlanCode }}
          </eui-btn>
        </template>
        <template #operation="{ scope }">
          <eui-btn
            v-if="
              getTableStatus(scope.row.purchasePlanStatus, 'record') ||
              scope.row.purchasePlanStatus === 4
            "
            type="link"
            font-size="12px"
            @click="handleRecord(scope.row)"
          >
            审核记录
          </eui-btn>
          <eui-btn
            v-if="
              getTableStatus(scope.row.purchasePlanStatus, 'edit') ||
              scope.row.purchasePlanStatus === 4
            "
            type="link"
            font-size="12px"
            @click="handleEdit(scope.row)"
          >
            修改
          </eui-btn>

          <eui-btn
            v-if="
              scope.row.purchasePlanStatus === 0 ||
              scope.row.purchasePlanStatus === 4
            "
            type="link"
            font-size="12px"
            @click="openDeleteDialog(scope.row.purchasePlanId)"
          >
            删除
          </eui-btn>
        </template>
      </e-table-list>
      <!-- 分页 -->
      <div class="pagination">
        <el-pagination
          style="margin-top: 20px"
          :pager-count="5"
          :page-sizes="[10, 20, 30]"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="queryData.pageNum"
          :total="pageTotal"
          :page-size.sync="queryData.pageSize"
          prev-text="上一页"
          next-text="下一页"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        ></el-pagination>
      </div>
    </div>

    <!-- 审核记录弹框 -->
    <e-dialog
      :dialog-title="'审核记录'"
      :center-dialog-visible="visible"
      :popup-width="'700px'"
      :show-btn="false"
      @resetPopupData="
        () => {
          visible = false;
        }
      "
    >
      <e-table-list
        :table-data="tableDataRecord"
        :table-label="tableLabelRecord"
        :index-show="true"
      ></e-table-list>
      <div class="flex-r">
        <el-pagination
          style="margin-top: 20px"
          :pager-count="5"
          :page-sizes="[10, 20, 30]"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="recordData.pageNum"
          :total="recordTotal"
          :page-size.sync="recordData.pageSize"
          prev-text="上一页"
          next-text="下一页"
          @size-change="handleSizeRecord"
          @current-change="handleCurrentRecord"
        ></el-pagination>
      </div>
    </e-dialog>

    <!-- 删除弹窗 -->
    <prompt-modal
      :prompt-modal-visible="delVisible"
      :footer="true"
      @close="closeDia"
    >
      <div slot="title" class="prompt-modal-title">
        <!-- <img src="@/static/common/warnIcon.png" alt /> -->
        <p>删除操作</p>
      </div>
      <div slot="content" class="prompt-modal-content">
        <h4>删除后不可恢复，确认删除吗?</h4>
      </div>
      <div slot="footer">
        <el-button class="btn-80-30" @click="closeDia">关闭</el-button>
        <el-button
          v-prevent-re-click
          class="btn-80-30-primary"
          type="primary"
          @click="handleDelete"
        >
          删除
        </el-button>
      </div>
    </prompt-modal>
  </div>
</template>

<script>
import PromptModal from '@/modules/projectA/components/common/promptModal.vue';
import eSearch from '@/modules/projectA/components/common/e-search.vue';
import eTableList from '@/modules/projectA/components/common/e-table-list';
import eDialog from '@/modules/projectA/components/common/e-dialog';
import utils from '@/modules/projectA/utils/utils';
import Api from '@/modules/projectA/api/purchase';

export default {
  components: {
    PromptModal,
    eSearch,
    eTableList,
    eDialog,
  },
  data() {
    return {
      visible: false,
      tableData: [],
      recordTotal: 0,
      tableDataRecord: [],
      tableLabelRecord: [
        {
          label: '审核人部门',
          param: 'departmentName',
          align: 'center',
        },
        {
          label: '审核人',
          param: 'auditMemberName',
          align: 'center',
        },
        {
          label: '审核时间',
          param: 'logTime',
          align: 'center',
        },
        {
          label: '审核状态',
          align: 'center',
          render: (row) => {
            const obj = {
              1: '通过',
              2: '拒绝',
            };
            return obj[Number(row.auditStatus)];
          },
        },
        {
          label: '意见说明',
          param: 'auditRemake',
          align: 'center',
        },
      ],
      pageTotal: 0,
      recordData: {
        pageSize: 10,
        pageNum: 1,
        businessId: null,
        businessAuditType: 4,
      },
      tableLabel: [
        {
          label: '采购计划编号',
          param: 'purchasePlanCode',
          align: 'center',
          minWidth: '160',
          slot: 'code',
        },
        {
          label: '采购计划名称',
          param: 'purchasePlanName',
          align: 'center',
          tooltip: true,
          minWidth: '220',
        },
        {
          label: '创建日期',
          param: 'createTime',
          align: 'center',
          minWidth: '150',
        },
        {
          label: '创建人',
          param: 'createMemberName',
          align: 'center',
          minWidth: '150',
        },
        {
          label: '审核状态',
          param: 'purchasePlanStatusDesc',
          align: 'center',
          /* render: row => {
            let obj = {
              0: "新建",
              1: "待审核",
              2: "审核通过",
              3: "审核驳回",
              4: "退回",
            };
            return obj[Number(row.purchasePlanStatus)];
          }, */
          minWidth: '120',
        },
        { label: '操作', align: 'center', slot: 'operation', width: '200' },
      ],
      queryData: {
        purchasePlanName: '',
        purchasePlanCode: '',
        createTime: '',
        purchasePlanStatus: null,
        pageNum: 1,
        pageSize: 10,
      },
      fieldList: [
        {
          label: '采购计划名称',
          type: 'input',
          value: 'purchasePlanName',
        },
        {
          label: '采购计划编号',
          type: 'input',
          value: 'purchasePlanCode',
        },
        {
          label: '提交时间',
          type: 'date',
          value: 'createTime',
          defaultTime: ['00:00:00', '23:59:59'],
          valueFormat: 'yyyy-MM-dd HH:mm:ss',
          dateType: 'daterange',
        },
        {
          label: '审核状态',
          type: 'select',
          placeholder: '请选择',
          value: 'purchasePlanStatus',
          list: 'purchasePlanStatusList',
        },
      ],
      listTypeInfo: {
        purchasePlanStatusList: [
          { name: '新建', id: 0 },
          { name: '待审核', id: 1 },
          { name: '审核通过', id: 2 },
          { name: '驳回', id: 3 },
          { name: '退回', id: 4 },
        ],
      },
      //
      delVisible: false,
      purchasePlanId: undefined,
    };
  },
  mounted() {
    this.purchasePlanQueryList();
  },

  methods: {
    openDeleteDialog(purchasePlanId) {
      this.delVisible = true;
      this.purchasePlanId = purchasePlanId;
    },
    closeDia() {
      this.delVisible = false;
      this.purchasePlanId = undefined;
    },
    // 新迭代 --- 结束
    async exporPlanTrackLogSummary() {
      const res = await Api.exporPlanTrackLogSummary(this.queryData);
      if (res.type === 'application/json') {
        utils.fileExportResponseError(res);
      } else {
        utils.downFile(res, '采购计划概要');
      }
    },

    async exportPlanTrackLogDetail() {
      const res = await Api.exportPlanTrackLogDetail(this.queryData);
      if (res.type === 'application/json') {
        utils.fileExportResponseError(res);
      } else {
        utils.downFile(res, '采购计划详情');
      }
    },
    // 查看采购计划详情
    handleCodeDetail(row) {
      this.$router.push({
        path: `/plan/purchaseQuery/purchaseDetail`,
        query: { ...row },
      });
    },

    // 采购计划执行接口
    async purchasePlanQueryList() {
      const params = { ...this.queryData };
      delete params.createTime;
      const res = await Api.purchasePlanQueryList(params);
      if (res.code === '200') {
        this.tableData = res.data.records;
        this.pageTotal = res.data.total;
      }
    },
    // table-btn 状态
    getTableStatus(row, type) {
      let flag = false;
      switch (type) {
        case 'edit':
          // case "submit":
          // 新建或驳回支持修改
          // 新建 和 驳回可以提交
          if (row === 0 || row === 3) {
            flag = true;
          } else {
            flag = false;
          }
          break;
        case 'record':
          // 审核通过、待审核、驳回状态可查看审核记录
          if (row === 2 || row === 1 || row === 3) {
            flag = true;
          } else {
            flag = false;
          }
          break;
        default:
          flag = false;
      }
      return flag;
    },

    // 修改
    handleEdit(row) {
      this.$router.push({
        path: '/plan/purchaseWayEdit/handCreated',
        query: {
          pageType: 'change',
          ...row,
        },
      });
    },
    // 查看审核记录
    async handleRecord(row) {
      this.visible = true;
      this.recordData.businessId = row.purchasePlanId;
      this.businessAuditLogPage();
    },
    async businessAuditLogPage() {
      const res = await Api.businessAuditLogPage(this.recordData);
      if (res.code === '200') {
        this.visible = true;
        this.tableDataRecord = res.data.records;
        this.recordTotal = res.data.total;
      }
    },
    async handleDelete() {
      const result = await Api.purchasePlanDelete({
        purchasePlanId: this.purchasePlanId,
      });
      if (result.code === '200') {
        this.closeDia();
        this.purchasePlanQueryList();
        this.$message({
          type: 'success',
          message: '删除成功!',
        });
      }
    },
    // 查询
    handleFilter(val) {
      this.queryData = val;
      this.queryData.pageNum = 1;
      this.queryData.startTime = val.createTime ? val.createTime[0] : '';
      this.queryData.endTime = val.createTime ? val.createTime[1] : '';
      this.purchasePlanQueryList();
    },
    // 重置
    handleReset() {
      this.queryData = this.$options.data().queryData;
      this.purchasePlanQueryList();
    },
    // 分页
    handleCurrentChange(val) {
      this.queryData.pageNum = val;
      this.purchasePlanQueryList();
    },
    handleSizeChange(val) {
      this.queryData.pageNum = 1;
      this.queryData.pageSize = val;
      this.purchasePlanQueryList();
    },
    handleCurrentRecord(val) {
      this.recordData.pageNum = val;
      this.businessAuditLogPage();
    },
    handleSizeRecord(val) {
      this.recordData.pageNum = 1;
      this.recordData.pageSize = val;
      this.businessAuditLogPage();
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/css/theme.scss';
.content {
  background: #fff;
}
::v-deep .el-table {
  th.el-table__cell > .cell {
    font-weight: normal;
    font-size: 14px;
  }
}
.search-box {
  padding: 10px 20px 10px 36px;
  border: 1px solid #d9d9d9;
  box-sizing: border-box;
  margin-bottom: 20px;
}
.active-btn {
  background: #ccc;
}
.export-wrapper {
  margin-bottom: 20px;
  float: left;
}
.search-btn {
  display: flex;
  flex-direction: row;
  justify-content: center;

  .btn {
    width: 80px;
    text-align: center;
    height: 30px;
    line-height: 27px;
    cursor: pointer;
  }

  .reset-btn {
    background: #e8efff;
    border: 1px solid #2587ff;
    color: #2587ff;
    margin-right: 30px;
    line-height: 27px;
    &:hover,
    :active {
      background-color: #126edf;
      color: #fff;
    }
  }
  .submit-btn {
    background: #2587ff;
    border: 1px solid #2587ff;
    color: #ffffff;
    margin-right: 10px;
    &:hover,
    :active {
      background-color: #126edf;
    }
  }
}
.prompt-modal-title {
  display: flex;
  height: 40px;
  padding-left: 20px;
  align-items: center;

  img {
    width: 18px;
    height: 18px;
    margin-right: 10px;
    vertical-align: middle;
  }

  p {
    font-size: 14px;
    font-weight: 500;
    color: $c3;
    line-height: 14px;
  }
}

.prompt-modal-content {
  > h4 {
    font-weight: 500;
    color: $c3;
    margin-bottom: 5px;
  }
}
.pagination-box {
  text-align: right;
}
</style>
